import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PreviewReview {
  id: string;
  rating: number;
  description: string;
  created_at: string;
  reviewer_firstname: string;
  reviewer_lastname: string;
  business_id: string;
  business_name: string;
  user_id: string;  // Changed from reviewer_id to user_id
}

export function usePreviewReviews(communityId?: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ['preview-reviews', communityId],
    enabled: enabled && !!communityId,
    queryFn: async () => {
      if (!communityId) return [];

      const { data, error } = await supabase
        .from('reviews')
        .select(`
          id,
          rating,
          description,
          created_at,
          user_id,
          business_id,
          user_profiles!fk_reviews_user_profiles (
            firstname,
            lastname
          ),
          businesses!reviews_business_id_fkey (
            name,
            community_id
          )
        `)
        .eq('businesses.community_id', communityId)
        .eq('status', 'Published')
        .order('created_at', { ascending: false })
        .limit(20);

      if (error) {
        console.error('Error fetching reviews:', error);
        throw error;
      }

      return (data || []).map((review: any) => ({
        id: review.id,
        rating: review.rating,
        description: review.description,
        created_at: review.created_at,
        reviewer_firstname: review.user_profiles?.firstname || '',
        reviewer_lastname: review.user_profiles?.lastname || '',
        business_id: review.business_id,
        business_name: review.businesses?.name || '',
        user_id: review.user_id
      })) as PreviewReview[];
    },
  });
}